import { AfterViewChecked, Component, EventEmitter, Input, Output, QueryList, ViewChildren } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { SurveyQuestionComponent } from '../survey-question/survey-question.component';
import { ConsentAnswers, Survey, SurveyService } from '../services/survey.service';

@Component({
    selector: 'ell-survey-consent',
    standalone: true,
    imports: [RouterLink, SurveyQuestionComponent, FormsModule],
    templateUrl: './survey-consent.component.html',
    styleUrl: './survey-consent.component.scss'
})
export class SurveyConsentComponent implements AfterViewChecked {
    error = '';

    answers: ConsentAnswers = {
        consentGiven: false
    };

    page = 1;

    @Input()
    survey?: Survey;

    @Output()
    complete = new EventEmitter<ConsentAnswers>();

    @ViewChildren(SurveyQuestionComponent)
    questions!: QueryList<SurveyQuestionComponent<any>>;

    constructor(private surveyService: SurveyService) {
    }

    next() {
        this.error = '';

        switch (this.page) {
            case 1:
                if (!this.answers.consentGiven) {
                    this.error = $localize`You have decided not to contribute data at this time. Please feel free to return to this site at a later date.`;
                } else {
                    this.complete.emit(this.answers);
                    return;
                }
        }

        if (!this.error) {
            this.page++;
        }
    }

    ngAfterViewChecked(): void {
        if (this.survey) {
            this.surveyService.registerQuestions(this.survey, this.questions);
        }
    }
}
